module.exports = __webpack_public_path__ + "static/img/course-tip-bg.a7f9d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/course-tip-bg.png
// module id = fR2j
// module chunks = 1